<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 375 647"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.7">
      <rect
        x="262"
        y="133.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 262 133.204)"
        class="lighter-fill"
      />
      <rect
        x="238"
        y="133.306"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 238 133.306)"
        class="darker-fill"
      />
      <rect
        x="238"
        y="557.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 238 557.204)"
        class="darker-fill"
      />
      <rect
        x="238"
        y="572.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 238 572.204)"
        class="lighter-fill"
      />
      <rect
        x="-252"
        y="516.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -252 516.102)"
        class="lighter-fill"
      />
      <rect
        x="-231.908"
        y="493.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -231.908 493.204)"
        class="darker-fill"
      />
      <rect
        x="-252"
        y="742.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -252 742.102)"
        class="lighter-fill"
      />
      <rect
        x="-231.908"
        y="719.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -231.908 719.204)"
        class="darker-fill"
      />
      <rect
        x="-165"
        y="183.102"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -165 183.102)"
        class="lighter-fill"
      />
      <rect
        x="-144.908"
        y="160.204"
        width="309"
        height="23"
        rx="11.5"
        transform="rotate(-25.5363 -144.908 160.204)"
        class="darker-fill"
      />
    </g>
  </svg>
</template>

<script>
export default {};
</script>

<style lang="scss" scoped>
@import "../scss/variables.scss";

svg {
  width: 100%;
  height: 100%;
  position: absolute;
  background-color: $quaternary-lighter;
}

.lighter-fill {
  fill: $secondary-lighter;
}

.darker-fill {
  fill: $secondary-darker;
}
</style>
